<div class="container">
  <div>
    <div class="head">
      {{ 'MENU_EDIT.HEADER' | translate }}
    </div>
    <div>
      <a [routerLink]="['modifier-group']" mat-button>
        <span mat-menu-item>Modifier groups</span>
      </a>
    </div>
  </div>

  <router-outlet></router-outlet>
</div>
